<template>
  <div class="participant-list">
    <el-checkbox-group v-model="checkedList">
      <div v-for="(item, index) in participants" :key="item.mid" :data-index="index"
        :class="{ 'participant-card': true, 'selected-participant-card': checkedList.includes(item.mid) }"
        @click="handleParticipantClick($event, index)" :style="cardStyle(index)">
        <div class="participant-left">

          <div class="participant-card-text">

            <div v-show="index == 0" class="participant-text2">{{$t('MAIN_PERSON')}}</div>
            <div v-show="index !== 0" class="participant-text2">{{$t('CHILD')}}</div>
            <br />
            <div class="participant-text">{{ item.name }}</div>
            <br />
            <div class="participant-desc">{{ item.address }}</div>
          </div>
        </div>
        <el-checkbox v-show="index !== 0" :label="item.mid"><br /></el-checkbox>
      </div>
    </el-checkbox-group>
  </div>
</template>
  
<script>
const cardColorList = ["#d9ebe7", "#dfeaf5", "#faedd9"];

export default {
  props: {
    participants: Array,
  },

  watch: {
    participants: function () {
      this.selectAll();
    }
  },
  data() {
    return {
      checkedList: [],
    };
  },
  mounted() { },
  methods: {
    handleParticipantClick(event, index) {
      event.preventDefault();
      if (index == 0) { return }
      const person = this.participants[index];
      const selectId = person.mid;

      this.checkedList = this.checkedList.includes(selectId)
        ? this.checkedList.filter((item) => item !== selectId)
        : [...this.checkedList, selectId];

    },

    cardStyle(index) {
      return {
        "background-color": cardColorList[index % cardColorList.length],
      };
    },

    selectAll() {
      this.checkedList = this.participants.map(x => x.mid);
    }
  },
};
</script>
  
<style lang="scss">
.participant-list {
  /*
    display: flex;
    flex-wrap: wrap;
    */
  width: 100%;

  .el-checkbox__inner {
    width: 26px;
    height: 26px;
  }

  .el-checkbox__inner::after {
    left: 9px;
    top: 5px;
    width: 6px;
    height: 10px;
  }
}

.participant-card {
  padding: 15px;
  border-radius: 8px;
  height: 90px;
  margin-bottom: 24px;
  display: flex;
  justify-content: space-between;
  cursor: pointer;
  max-width: 300px;
}

.participant-left {
  display: flex;
  justify-items: center;
  align-items: center;
}




.participant-text {
  color: #414040;
  font-size: 18px;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  display: -webkit-inline-box;
  word-break: break-word;
  padding-bottom: 5px;
}

.participant-text2 {
  color: #13a07b;
  font-size: 18px;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  display: -webkit-inline-box;
  word-break: break-word;
  padding-bottom: 10px;
}

.participant-desc {
  -webkit-line-clamp: 6;
  -webkit-box-orient: vertical;
  overflow: hidden;
  display: -webkit-inline-box;
  font-size: 13px;
  color: #888;
  font-weight: normal;
  word-break: break-word;
}

.participant-card .el-checkbox {
  padding: 35px 0;
}

.participant-card .el-checkbox__inner {
  border-radius: 50%;
  border: 1px solid #00785d;
}

.selected-participant-card {
  border: 1px solid #00785d;
}
</style>